export default __webpack_public_path__ + "static/media/DinosaurTrain_02.aa04b422.png";